import { RequestService } from '@tcc-online/request-service';
import ProjectJobMatching from '../types/jobMatch/ProjectJobMatching';
import ProjectAvailableJobMatching from '../types/jobMatch/ProjectAvailableJobMatching';
import AdminJobMatchingResponse from '../types/jobMatch/AdminJobMatchingResponse';

const AdminJobMatchService = {
    getJobMatchings,
    getAvailableJobMatchings,
    assignProject,
    createFromTeam,
    createFromProjectTeam,
};

export interface CreateFromTeamPayload {
    teamId: number;
    name?: string | null;
}

export interface CreateFromProjectTeamPayload extends CreateFromTeamPayload {
    productId: number;
    projectId: number;
}

const BASE_URL = '/admin/products';

export interface BasePayload {
    productId: number;
    projectId: number;
}

const createUrl = (productId: number, projectId: number) => {
    return `${BASE_URL}/${productId}/projects/${projectId}/job-matchings`;
};

async function getJobMatchings(payload: BasePayload) {
    const { productId, projectId } = payload;
    return await RequestService.get<ProjectJobMatching[]>(
        createUrl(productId, projectId),
    );
}

type AssignPayload = {
    jobMatchings: { jobMatchingId: number }[];
};

async function assignProject(payload: BasePayload & AssignPayload) {
    const { productId, projectId, jobMatchings } = payload;
    return await RequestService.post<
        { jobMatchingId: number }[],
        ProjectJobMatching[]
    >(createUrl(productId, projectId), jobMatchings);
}

async function getAvailableJobMatchings(payload: BasePayload) {
    const { productId, projectId } = payload;
    return await RequestService.get<ProjectAvailableJobMatching[]>(
        createUrl(productId, projectId) + '/available',
    );
}

async function createFromTeam(payload: CreateFromTeamPayload) {
    const { teamId, name } = payload;
    return await RequestService.post<
        { name: string | null },
        AdminJobMatchingResponse
    >(`/admin/job-matchings/from-team/${teamId}`, { name: name ?? null });
}

async function createFromProjectTeam(payload: CreateFromProjectTeamPayload) {
    const { productId, projectId, teamId, name } = payload;
    return await RequestService.post<
        { name: string | null },
        AdminJobMatchingResponse
    >(
        `/admin/products/${productId}/projects/${projectId}/job-matchings/from-team/${teamId}`,
        { name: name ?? null },
    );
}

export default AdminJobMatchService;
